import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import InputBox from "../../component/InputBox";
import NormalSelect from "../../component/NormalSelect";
import Exported from "../../service/endpoints";
import request from "../../service";
import { Toast } from "../../service/toast";
import SearchableSelect from "../../component/SearchSelect";
import classes from "./style.module.scss";
import Button from "../../component/Button";

function AddPoints() {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const [statusOptions] = useState([
    { label: "Filters", value: "3" },
    { label: "Truck Solutions", value: "4" },
    { label: "Bearings", value: "1" },
    { label: "Bulk Filtration", value: "2" },
    { label: "Promo", value: "5" },
  ]);

  const errorMessageStyle = {
    color: "#fc8181",
    fontSize: "14px",
    marginTop: "4px",
    marginLeft: "14px",
  };

  const [productOptions, setProductOptions] = useState([]);
  const [filterValue, setFilterValue] = useState(""); // Track the selected category value
  const selectedCategory = watch("productCategory");
  const [selectedProduct, setSelectedProduct] = useState("");

  const getLabelValue = (value) => {
    return statusOptions?.find((x) => x?.value === value)?.label || "";
  };

  useEffect(() => {
    if (filterValue) {
      fetchProductOptions(filterValue);
      setValue("selectedProduct", ""); // reset selected product
      setSelectedProduct("");
    } else {
      setProductOptions([]);
    }
  }, [filterValue]);

  const fetchProductOptions = async (categoryValue) => {
    try {
      const res = await request({
        url: Exported.Endpoints.getProductList,
        params: {
          type: 1,
          category: categoryValue,
        },
      });

      if (res?.data?.status) {
        const options = res?.data?.data?.map((it) => ({
          label: it?.product_details?.reference_number,
          value: it?.product_details?.id,
        }));
        setProductOptions(options);
      }
    } catch (err) {
      console.log(err);
      Toast({ type: "error", message: "Failed to fetch products" });
    }
  };

  const handleStatusChange = (value) => {
    setFilterValue(value);
    setValue("productCategory", value); // Update form value
  };

  const onSubmit = (data) => {
    const payload = {
      email: data.emailid,
      points_name: data.pointsName,
      points: parseInt(data.points),
      product_id: data.selectedProduct || null,
    };

    console.log("Payload to Send:", payload);

    request({
      url: Exported.Endpoints.addPoints,
      method: "PUT",
      data: payload,
    })
      .then((res) => {
        if (res?.data?.status) {
          Toast({ type: "success", message: "Points added successfully!" });
          reset();
          setSelectedProduct("");
          setFilterValue("");
        } else {
          Toast({
            type: "error",
            message: res?.data?.message || "Failed to add points",
          });
        }
      })
      .catch((err) => {
        console.error(err);
        Toast({ type: "error", message: err?.response?.data?.message  || "Failed to add points", });
      });
  };

  const selectContainerStyle =
    "w-[430px] border-[#D9D9D9] bg-white rounded-md border-[1px] h-[52px] flex items-center";

  return (
    <div className="p-1">
      <div className="w-[530px] layout-title mb-3 fs-4 fw-bold">Add Points</div>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-4 w-full flex-wrap"
      >
        {/* Email */}
        <div className="flex flex-row gap-4 w-full flex-wrap">

        <div className="flex flex-col gap-4">
          <div className={`${classes.formField}`}>
            <InputBox
              label="Email ID*"
              name="emailid"
              placeholder="Enter Email"
              {...register("emailid", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email format",
                },
              })}
              className="w-[530px]"
              error={!!errors.emailid}
              messages={errors.emailid?.message}
            />
          </div>
          {/* Points Name */}
          <div className={`${classes.formField}`}>
            <InputBox
              label="Points Name*"
              name="pointsName"
              placeholder="Enter Points Name"
              {...register("pointsName", {
                required: "Points Name is required",
              })}
              error={!!errors.pointsName}
              message={errors.pointsName?.message}
              className="w-[530px]"
              />
          </div>
          {/* Points */}
          <div className={`${classes.formField}`}>
            <InputBox
              label="Points*"
              name="points"
              placeholder="Enter Points*"
              type="number"
              {...register("points", {
                required: "Points are required",
                min: { value: 0, message: "Must be positive" },
              })}
              error={!!errors.points}
              message={errors.points?.message} 
              className="w-[530px]"
            />
          </div>
         
        </div>
        <div className="flex flex-col gap-4">
          {/* Product Category */}
          <div className={selectContainerStyle}>
            <Controller
              name="productCategory"
              control={control}
              rules={{ required: "Category is required" }}
              render={({ field }) => (
                <NormalSelect
                  className="w-full pt-0"
                  list={statusOptions}
                  value={filterValue ? getLabelValue(filterValue) : null}
                  handleChange={handleStatusChange}
                  placeholder="Select Category"
                  label="Product Category"
                  error={errors.productCategory}
                  messages={errors.productCategory?.message}
                  borderTab
                />
              )}
              />
          </div>
          {/* Product Name */}
          <div>
          <div className="w-[430px] border-[#D9D9D9] bg-white rounded-md border-[1px] my-3">
            <Controller
              name="selectedProduct"
              control={control}
              rules={{
                required: "Product selection is required",
              }}
              render={({ field }) => (
                <SearchableSelect
                  value={field.value}
                  handleChange={(val) => {
                    field.onChange(val);
                    setSelectedProduct(val);
                  }}
                  label="Product Name"
                  placeholder="Search Product"
                  options={productOptions}
                  required
                  />
              )}
            />
          </div>
          {errors.selectedProduct && (
              <div style={errorMessageStyle}>
                {errors.selectedProduct.message}
              </div>
            )}
            </div>
        </div>
        </div>
        <button
            type="submit"
            className="w-[530px] bg-[#1f2155] text-white px-6 py-3 rounded-[15px] hover:bg-[#1f2155] transition duration-300 "
            >
            Add Points
          </button>
      </form>
    </div>
  );
}

export default AddPoints;
